import React from 'react';
import { Header, Product, About, Footer } from './containers';
import { Navbar } from './components';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Header />
      <Product />
      <About />
      <Footer />
    </div>
  );
}

export default App;
